import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'format',
})
export class FormatPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    switch (args[0]) {
      case 'replace':
        return value == undefined ? '' : this.replaceStr(value, args[1], args[2]);
        break;
      case 'encrypt':
        return value == undefined ? '' : this.encryptStr(value, args[1], args[2], args[3]);
        break;
    }
  }

  /**
   * 字符串替换
   * @param value
   * @param need
   * @param replace
   * @private
   */
  private replaceStr(value: any, need: any, replace: any): void {
    const newValue = value.replace(new RegExp(need, 'ig'), replace);
    return newValue;
  }

  /**
   * 字符串加密（手机号加密  身份证加密）
   * @param value 要脱敏的字符串
   * @param start 脱敏开始的位置
   * @param length 脱敏长度
   * @param replace 脱敏替换字符串
   * @private
   */
  private encryptStr(value: any, start: any, length: any, replace: any): string {
    let encrypt = '';
    for (let i = 0; i < length; i++) {
      encrypt = encrypt + '*';
    }
    const newValue = value.substring(0, start) + encrypt + value.substring(value.length - length);
    return newValue;
  }
}
